import STATIC_HI from "@/data/reportStaticHi.json";

export const tr = (text, lang) => (lang === "hi" ? STATIC_HI.ui_strings?.[text] || text : text);

export const trDim = (key, lang) =>
  lang === "hi" ? STATIC_HI.dimension_labels?.[key] || key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : null;
